import { render, staticRenderFns } from "./vip-tip.vue?vue&type=template&id=684bc9f2&scoped=true&"
import script from "./vip-tip.vue?vue&type=script&lang=js&"
export * from "./vip-tip.vue?vue&type=script&lang=js&"
import style0 from "./vip-tip.vue?vue&type=style&index=0&id=684bc9f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684bc9f2",
  null
  
)

export default component.exports